<app-shared-dialog
  [title]="'quotations_and_orders.source_content.duplicated_products' | translate"
  [options]="{
    size: 'large',
    titleIcon: 'duplicated',
    subTitle: 'quotations_and_orders.source_content.duplicated_products_warning' | translate,
    titleIconColor: 'danger',
    confirmText: ('common.remove' | translate) + ' ' + '(' + selectedOrderLineIds.size + ')',
    confirmIcon: 'trash-cc',
    confirmButtonStyle: 'danger-btn',
    confirmIconPosition: 'start',
    cancelText: 'common.cancel' | translate,
    cancelButtonStyle: 'secondary-btn',
    confirmDisabled: selectedOrderLineIds.size === 0
  }"
  (confirm)="save()"
  (cancel)="cancel()"
>
    <div class="dialog-content">
            <div class="validation-hint" *ngIf="attemptedSubmit && !canConfirm" style="margin-bottom: 12px; color: #b00020;">
                {{ 'quotations_and_orders.source_content.keep_at_least_one_product_unselected' | translate }}
            </div>
            <div class="product-table-container">
                <table class="product-table">
                    <thead>
                        <tr>
                            <th scope="col">Duplicates</th>
                            <th scope="col" class="col-brand">Quantity</th>
                        </tr>
                    </thead>
                    <tbody class="scrollable_body">
                        <ng-container *ngFor="let item of data">
                            <tr>
                                <td>
                                    <div class="product-container">
                                        <div class="col-img">
                                            <mat-checkbox
                                              [checked]="isSelected(item)"
                                              (change)="onToggleSelection(item, $event.checked)"
                                            ></mat-checkbox>
                                            <img [src]="item.image ? baseUrl + item.image + '?thumbnail=1' : placeholder" alt="">
                                        </div>
                                        <div class="product-info col-product">
                                            <div class="product-name">{{item.name}}</div>
                                            <div class="product-sku">{{item | productCode}}</div>
                                        </div> 
                                    </div>
                                </td>
                                <td class="col-qty">{{item.quantity}}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
    </div>
</app-shared-dialog>